export class ChangeEnableStoppingReasonTypeRuleModel {
    stoppingReasonTypeRuleId: number;
    description: string;
    isEnabled: boolean;
}